import { ThunkType } from "../../../../../core/store/reducers";
import { getTradeReviewExcel } from "../api/getTradeReviewExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../tradeReviewDataSlice";

export const downloadTradeReviewExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.exchbusiness.tradeReview;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getTradeReviewExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "TradeReview.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
